/**
 * Documentation KFP API
 * ## Common Request Headers - Authorization (string `Bearer {AccessToken}`, if signed-in) - After the client has successfully obtained `AccessToken` via Login, it\'s sent in every request as a bearer token.
 *
 * The version of the OpenAPI document: 1
 * Contact: novak@techcrowd.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserResource } from './userResource';
import { ItemResource } from './itemResource';


export interface GroupResource { 
    /**
     * Group ID
     */
    id: number;
    /**
     * test
     */
    title?: string;
    /**
     * test
     */
    description?: string;
    /**
     * test
     */
    stripeProductName?: string;
    /**
     * test
     */
    linkToSimpleShop?: string;
    /**
     * test
     */
    moreInfoLink?: string;
    /**
     * test
     */
    isVisibleDashboard?: boolean;
    /**
     * test
     */
    visibleForSelected?: boolean;
    created?: string;
    updated?: string;
    /**
     * List items from group
     */
    items?: Array<ItemResource>;
    /**
     * List users from group
     */
    users?: Array<UserResource>;
}

